<template>
  <div class="userstate">
    <div class="statebox" v-if="!hasRegistered">您还未报名，请点击报名入口报名</div>
    <div class="statebox" v-else>您已报名成功,信息正在审核中</div>
    <!-- <div class="statebox" v-if="signstate === 1">您的报名信息正在审核中...</div>
    <div class="statebox" v-if="signstate === 2">
      <p>您的审核未通过</p>
      <p style="color: #666">未提供有效从业证明/职业信息填写错误</p>
    </div> -->
  </div>
</template>

<script>
import { getRegistrationInfo } from "../API/user";

export default {
  components: {},
  props: {},
  data() {
    return {
      signstate: 2,
      hasRegistered:false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getUserState()
  },
  mounted() {},
  methods: {
    async getUserState() {
      const {data:res} = await getRegistrationInfo();
      this.hasRegistered = res.data.hasRegistered
    },
  },
};
</script>

<style lang="scss" scoped>
.userstate {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .statebox {
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    .el-link{
      font-size: 20px;
    }
    p {
      padding: 5px 0;
    }
  }
}
</style>
